import {
	BadgeCheck,
	Bell,
	Calendar,
	ChevronsUpDown,
	LogOut,
	Palette,
	Sparkles,
	Wrench,
} from "lucide-react";

import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	useSidebar,
} from "@/components/ui/sidebar";
import {NavLink} from "react-router-dom";

const settingsLinks = [
	{to: "/settings/access", label: "Доступы", icon: Sparkles},
	{to: "/settings/integrations", label: "Интеграции", icon: BadgeCheck},
	{to: "/settings/analysis", label: "Настройки анализа", icon: Bell},
	{to: "/settings/appearance", label: "Оформление", icon: Palette},
	{to: "/settings/periods", label: "Периоды", icon: Calendar},
	{to: "/settings/development", label: "Разработка", icon: Wrench},
	{to: "/settings/debug", label: "Отладка", icon: Wrench},
] as const;

export function NavUser({
	user,
	onLogout,
}: {
	user: {
		name: string
		email: string
	}
	onLogout: () => void
}) {
	const {isMobile} = useSidebar();

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<DropdownMenu>
					<DropdownMenuTrigger>
						<SidebarMenuButton
							size="lg"
							className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
						>
							<div className="grid flex-1 text-left text-sm leading-tight">
								<span className="truncate font-medium">{user.name}</span>
								<span className="truncate text-xs">{user.email}</span>
							</div>
							<ChevronsUpDown className="ml-auto size-4"/>
						</SidebarMenuButton>
					</DropdownMenuTrigger>
					<DropdownMenuContent
						className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
						side={isMobile ? "bottom" : "right"}
						align="end"
						sideOffset={4}
					>
						<DropdownMenuGroup>
							<DropdownMenuLabel className="p-0 font-normal">
								<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
									<div className="grid flex-1 text-left text-sm leading-tight">
										<span className="truncate font-medium">{user.name}</span>
										<span className="truncate text-xs">{user.email}</span>
									</div>
								</div>
							</DropdownMenuLabel>
						</DropdownMenuGroup>

						<DropdownMenuSeparator/>

						<DropdownMenuGroup>
							{settingsLinks.map(({to, label, icon: Icon}) => (
								<NavLink key={to} to={to} className="block">
									<DropdownMenuItem onSelect={(event) => event.preventDefault()}>
										<Icon/>
										{label}
									</DropdownMenuItem>
								</NavLink>
							))}
						</DropdownMenuGroup>

						<DropdownMenuSeparator/>

						<DropdownMenuGroup>
							<DropdownMenuItem onSelect={() => onLogout()}>
								<LogOut/>
								Выйти
							</DropdownMenuItem>
						</DropdownMenuGroup>
					</DropdownMenuContent>
				</DropdownMenu>
			</SidebarMenuItem>
		</SidebarMenu>
	);
}
